export const DEFAULT_VALUES = {
	crewMemberId: '',
	effectiveTimestamp: '',
	expireTimestamp: '',
	cityId: '',
};
